export default "dist/images/components-columns-width-control-2-2.0388d6b.png";